import React from "react";
import { DatePicker, Form, Icon, Input } from "antd";
import get from "lodash/get";
import { withNamespaces } from "react-i18next";
import { getDrugManagementStatus } from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import { connect } from "react-redux";

const { TextArea } = Input;

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

const ValidationFormStep3Component = (props) => {
  if (props.currentStep !== "Step 3") {
    return null;
  }
  return (
    <div className="form-group">
      <h5 style={{ display: "inline-block !important" }}>
        {props.i18n.t("Site ID")}:{" "}
        <h4 style={{ color: "var(--primary-color)", display: "inline-block" }}>
          {props.siteID}
        </h4>
      </h5>
      <h5 style={{ display: "inline-block !important" }}>
        {props.i18n.t("User ID")}:{" "}
        <h4 style={{ color: "var(--primary-color)", display: "inline-block" }}>
          {props.userID}
        </h4>
      </h5>
      <h5 style={{ display: "inline-block !important" }}>
        {props.i18n.t("Subject ID")}:{" "}
        <h4 style={{ color: "var(--primary-color)", display: "inline-block" }}>
          {props.subjectID}
        </h4>
      </h5>
      <h5 style={{ display: "inline-block !important" }}>
        {props.i18n.t("Validation Date")}:{" "}
        <h5 style={{ color: "var(--primary-color)", display: "inline-block" }}>
          {props.validationExistsDate}
        </h5>
      </h5>

      <hr />
      <p> </p>

      {props.validationExistsUsedRecommendedValues === "true" ? (
        <div>
          <p style={{ fontSize: "18px", display: "inline-block !important" }}>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:You indicated that the patient has received the assigned drug bottle"
            )}
          </p>
          {!!get(props, "subject.drug.vial_number") && <p>
            {props.i18n.t("Vial #")}: {get(props, "subject.drug.vial_number")}
          </p>}
          <p>
            {props.i18n.t("Deviation")}: {props.i18n.t("No")}
          </p>
        </div>
      ) : (
        <div>
          <p style={{ fontSize: "18px", display: "inline-block !important" }}>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:You indicated that the patient has not received the assigned drug package. Please enter which drug # was received and explain why in the comments box!"
            )}
          </p>
          <p>
            {props.i18n.t("Deviation")}: {props.i18n.t("Yes")}
          </p>
          {!!get(props, "subject.drug.vial_number") && <p>
            {props.i18n.t("Expected drug #")}:{" "}
            {get(props, "subject.drug.vial_number")}
          </p>}

          <Form.Item>
            <label>
              <b>
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep3:Actual used drug #"
                )}
              </b>

              {props.getFieldDecorator("actualUsedBottle", {
                initialValue: props.actualUsedBottle,
                onChange: props.handleChange,
                rules: [
                  {
                    required: props.isDrugManagementActive,
                    message: props.i18n.t("Required"),
                  },
                ],
              })(
                <Input
                  id="actualUsedBottle"
                  name="actualUsedBottle"
                  placeholder={props.i18n.t(
                    "NamespaceValidateRandomizationStep3:Please enter the actual used drug #"
                  )}
                  allowClear
                  size="large"
                />
              )}
            </label>
          </Form.Item>
        </div>
      )}

      <label>
        <h5>{props.i18n.t("Comments")}</h5>
        <Form.Item>
          {props.getFieldDecorator("validationExistsComments", {
            initialValue: props.validationExistsComments,
            onChange: props.handleChange,
            rules: [
              {
                required:
                  props.validationExistsUsedRecommendedValues !== "true" &&
                  props.isDrugManagementActive,
                message: props.i18n.t("Required"),
              },
            ],
          })(
            <TextArea
              id="validationExistsComments"
              name="validationExistsComments"
              prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
              placeholder={props.i18n.t("Comments")}
              allowClear
              autoFocus
              size="large"
              autoSize={{ minRows: 3, maxRows: 8 }}
            />
          )}
        </Form.Item>
      </label>

      <hr />
      <p> </p>

      {props.validationExistsDeviationOccurred === "true" ? (
        <div>
          <p style={{ fontSize: "18px", display: "inline-block !important" }}>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:You indicated that the drug has been returned by the patient or that other protocol deviations have occurred. Please explain what happened in the comments box"
            )}
          </p>
          <p>
            {props.i18n.t("Deviation")}: {props.i18n.t("Yes")}
          </p>
        </div>
      ) : (
        <div>
          <p style={{ fontSize: "18px", display: "inline-block !important" }}>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:You indicated that the drug has not been returned by the patient and that no other protocol deviations have occurred"
            )}
          </p>
          <p>
            {props.i18n.t("Deviation")}: {props.i18n.t("No")}
          </p>
        </div>
      )}

      <label>
        <h5>{props.i18n.t("Comments")}</h5>
        <Form.Item>
          {props.getFieldDecorator("validationDeviationExistsComments", {
            initialValue: props.validationDeviationExistsComments,
            onChange: props.handleChange,
            rules: [
              {
                required: props.validationExistsDeviationOccurred === "true",
                message: props.i18n.t("Required"),
              },
            ],
          })(
            <TextArea
              id="validationDeviationExistsComments"
              name="validationDeviationExistsComments"
              prefix={<Icon type="skin" style={{ color: "#FAFAFA" }} />}
              placeholder={props.i18n.t("Comments")}
              allowClear
              autoFocus
              size="large"
              autoSize={{ minRows: 3, maxRows: 8 }}
            />
          )}
        </Form.Item>
      </label>

      <hr />
      <p> </p>

      {props.validationPatientDied === "true" ? (
        <div>
          <p style={{ fontSize: "18px", display: "inline-block !important" }}>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:You indicated the patient has deceased. Please fill out the following information"
            )}
          </p>
          <p>
            {props.i18n.t("Death")}: {props.i18n.t("Yes")}
          </p>

          <p>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:Patient deceased date"
            )}
            :
          </p>
          <Form.Item>
            {props.getFieldDecorator("validationPatientDiedDate", {
              initialValue: props.validationPatientDiedDateMoment,
              onChange: props.handlePatientDiedDatePickerChange,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceValidateRandomizationStep3:Please enter the date"
                  ),
                },
              ],
            })(
              <DatePicker
                id="validationPatientDiedDate"
                name="validationPatientDiedDate"
                prefix={<Icon type="user" style={{ color: "#FAFAFA" }} />}
                placeholder={props.i18n.t(
                  "NamespaceValidateRandomizationStep3:Please enter the date"
                )}
                allowClear
                size="large"
                className="ant-input ant-input-lg"
              />
            )}
          </Form.Item>
        </div>
      ) : (
        <div>
          <p style={{ fontSize: "18px", display: "inline-block !important" }}>
            {props.i18n.t(
              "NamespaceValidateRandomizationStep3:You indicated that the patient is still alive."
            )}
          </p>
          <p>
            {props.i18n.t("Death")}: {props.i18n.t("No")}
          </p>
        </div>
      )}

      <label>
        <h5>{props.i18n.t("Comments")}</h5>
        <Form.Item>
          {props.getFieldDecorator("validationPatientDiedComments", {
            initialValue: props.validationPatientDiedComments,
            onChange: props.handleChange,
            rules: [
              {
                required: props.validationPatientDied === "true",
                message: props.i18n.t(
                  "NamespaceValidateRandomizationStep3:Please provide deviation comments"
                ),
              },
            ],
          })(
            <TextArea
              id="validationPatientDiedComments"
              name="validationPatientDiedComments"
              placeholder={props.i18n.t("Comments")}
              allowClear
              size="large"
              className="ant-input ant-input-lg"
            />
          )}
        </Form.Item>
      </label>

      <hr />
      <p> </p>
      <h4 style={{ display: "inline-block !important" }}>
        {props.i18n.t("NamespaceValidateRandomizationStep3:Validation Options")}
      </h4>

      <Form.Item>
        {props.getFieldDecorator("validationProvided", {
          initialValue: props.validationProvided,
          onChange: props.handleChange,
          rules: [
            {
              required: true,
              message: props.i18n.t(
                "NamespaceValidateRandomizationStep3:Do you confirm that the information presented above is correct and agree to validate the randomization information for this subject?"
              ),
            },
          ],
        })(
          <label>
            <h5>
              {props.i18n.t(
                "NamespaceValidateRandomizationStep3:Do you confirm that the information presented above is correct and agree to validate the randomization information for this subject? If no, please click on the Back button!"
              )}
            </h5>
            <select
              id="validationProvided"
              name="validationProvided"
              size="large"
              className="ant-input ant-input-lg"
            >
              <option value="">
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep3:Accept Validation?"
                )}
              </option>
              <option value="yes">{props.i18n.t("Yes")}</option>
              <option value="">{props.i18n.t("No")}</option>
            </select>
          </label>
        )}
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isDrugManagementActive: getDrugManagementStatus(state),
});

const mapDispatchToProps = { logout };

export const ValidationFormStep3 = connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ValidationFormStep3Component));



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/ValidateRandomizationStep3.js